import axios from 'axios'
import {
	Message,
	Loading
} from 'element-ui'

// import {
// 	getUserInfo
// } from '@/api/employee'

// import {
// 	getLoginUserInfo
// } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
	//baseURL: this.$httpurl, // api的base_url
	timeout: 90000 // 请求超时时间
})

service.interceptors.request.use(
	(config) => {
	  // 在请求发起时显示加载动画
	  const loadingInstance = Loading.service({
		lock: true,
		text: '加载中...',
		background: 'rgba(0, 0, 0, 0.7)',
	  });
  
	  // 将 loadingInstance 挂载到 config 上，方便在响应拦截器中使用
	  config.__loadingInstance = loadingInstance;
  
	  return config;
	},
	(error) => {
	  // 请求错误时关闭加载动画
	  if (error.config && error.config.__loadingInstance) {
		error.config.__loadingInstance.close();
	  }
	  return Promise.reject(error);
	}
  );

// respone拦截器
service.interceptors.response.use(
	response => {
		if (response.config.__loadingInstance) {
			response.config.__loadingInstance.close();
		}
		const res = response.data
		if (res.ErrCode == 4||res.errCode == 4||res.ErrCode == 0||res.ErrCode==404||res.errCode == 0
			||res.errCode==404 ||res.errCode == 2100 || res.ErrCode==2100) {
			return res;
		} else {
			Message({
				message: res.ErrMsg,
				type: 'error',
				duration: 3 * 1000
			});
			 return Promise.reject('error');
		}
	},
	error => {
		if (error.config && error.config.__loadingInstance) {
			error.config.__loadingInstance.close();
		}
		Message({
			message: error.message,
			type: 'error',
			duration: 3 * 1000
		})
		return Promise.reject(error);
	}
)

export default service
